import React, { useEffect, useState } from "react";
import { Button, Col, FormControl, Modal, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import { FaCheckCircle } from "react-icons/fa";
import { MdError } from "react-icons/md";
import { useAuthState } from "../../context/AuthContext";
import EmployeeStage from "./new_anlage/EmployeeStage";


/**
 * ChangeAnlageModal
 * 
 * To change data from Anlage, customer needs to write what
 * he wants to change in textarea. Backend will open new 
 * Ticket for this changes.
 * 
 * @param {param} anlage object anlage which should be edited
 * @param {param} show bool to display/hide modal
 * @param {param} setShow setter for bool display/hide
 * @param {param} noContact bool optional when true contact wont be used
 * 
 * @returns Modal
 */
const ChangeAnlageModal = ({anlage, show, setShow, noContact}) => {

    const API = new PrivateApi();
    const { contactPerson, user } = useAuthState();
    const [stage, setStage] = useState("default");
    const [changeBox, setChangeBox] = useState("");
    const [boxEmpty, setBoxEmpty] = useState(false);

    useEffect(() => {
        if (show) {
            if (contactPerson || noContact) {
                setStage("default");
            } else {
                setStage("contact");
            }
            setChangeBox("");
        }
    }, [show])

    const sendDataHandler = () => {
        if (changeBox.length < 4) return setBoxEmpty(true);
        setStage("loading");
        var data = {anlage: anlage, changeBox: changeBox};
        if (user.x_is_house_management !== false) data['contactPerson'] = contactPerson;
        else data['contactPerson'] = user;
        API.hw_Anlagen_edit(data)
            .then(() => {
                setStage("success");
            })
            .catch(() => {
                setStage("error");
            }
        );
    }

    return (
        <Modal show={show}>
            <Modal.Header closeButton onHide={() => setShow(false)}>
                <Modal.Title>Ticket zu Anlage {anlage.x_studio_field_mWMGR}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    stage === 'contact' ? 
                        <EmployeeStage setStage={setStage} setShow={setShow} /> :
                    stage === 'default' ?
                        <Row className="mt-3">
                            <Col xl="12">
                                <p className="text-muted">Bitte teilen Sie uns mit, welche Daten geändert werden sollen.<br/><br/> Beispiele: Zähler mit der Nummer "123456" wurde demontiert; Bestandseinheitennummer ist "12345"; Anlagenverwendung ist "Beleuchtung Gang 3"</p>
                                <p className="text-muted">Alternativ können Sie hier auch eine Frage an uns zu dieser Anlage hinterlassen.</p>
                                <FormControl 
                                    as="textarea" 
                                    value={changeBox} 
                                    onChange={e => setChangeBox(e.target.value)} 
                                    style={{height: "150px"}} 
                                    isValid={changeBox.length > 3}
                                    isInvalid={boxEmpty}
                                />
                            </Col>
                        </Row> :
                    stage === 'loading' ?
                        <Row className="mt-3 text-center">
                            <Col xl="12">
                                <h5>Daten werden übermittelt</h5>
                                <Spinner animation="grow" className="text-energo" />&nbsp;
                                <Spinner animation="grow" className="text-energo" />&nbsp;
                                <Spinner animation="grow" className="text-energo" />
                            </Col>
                        </Row> :
                    stage === "success" ?
                        <Row className="mt-3 text-center">
                            <Col xl="12">
                                <h5>Daten übermittelt</h5>
                                <FaCheckCircle size={50} className="mt-3 text-energo" />
                                <p className="mt-4">Anlagendaten wurden an ENERGO gesendet und werden in Kürze verarbeitet.</p>
                            </Col>
                        </Row> :
                    stage === "error" ?
                        <Row className="mt-3 text-center">
                            <Col xl="12">
                                <h5 className="text-danger">Fehler aufgetreten</h5>
                                <MdError size={50} className="text-danger mt-3" />
                                <p className="mt-4">Leider ist bei der Übermittlung der Daten ein Fehler aufgetreten. Bitte kontaktieren Sie den Support, wenn der Fehler erneut auftritt.</p>
                            </Col>
                        </Row> :
                    null
                }
            </Modal.Body>
            <Modal.Footer hidden={stage === "contact"}>
                {stage === "default"?
                    <>
                        <Button onClick={() => setShow(false)} variant="warning">Abbrechen</Button>
                        <Button onClick={() => sendDataHandler()} className="btn-energo">Absenden</Button>
                    </>:
                stage === "success"?
                    <Button className="btn-energo" onClick={() => setShow(false)}>Ok</Button> :
                    null
                }
            </Modal.Footer>
        </Modal>
    )
}

export default ChangeAnlageModal;